module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" preserveAspectRatio=\"xMidYMid\" viewBox=\"0 0 24 24\"><path d=\"M23 13H13v10a1 1 0 0 1-2 0V13H1a1 1 0 0 1 0-2h10V1a1 1 0 0 1 2 0v10h10a1 1 0 0 1 0 2z\" class=\"cls-1\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-inline-loader?removeTags=true!./src/images/svg/plus.svg
// module id = EI0t
// module chunks = 89